import { microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { i18n } from '@b2ag/locale'
import { useRouter } from 'vue-router'
import { PAGE_TYPE } from '../page-types'

/* ------- MICROFRONT - LANDING ------- */

export const landingMainRoutes = [
  {
    path: '/aide',
    name: 'contact',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'aide',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/a-propos',
    name: 'about',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'about',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/nos-partenaires',
    name: 'partners',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'partners',
        metaInfos: {
          title: i18n._('PAGE_NOS_PARTENAIRES_TITRE'),
          description: i18n._('PAGE_NOS_PARTENAIRES_DESCRIPTION'),
        },
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/nos-marques',
    name: 'brands',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'brands',
        metaInfos: {
          title: i18n._('LANDING_BRAND_TITLE'),
          description: i18n._('LANDING_BRAND_DESCRIPTION'),
        },
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: useAnalyticService(),
      })
    },
  },
  {
    path: '/modes-de-livraison',
    name: 'delivery-modes',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'livraisons',
        metaInfos: {
          title: i18n._('LANDING_DELIVERY_METHODS_TITLE'),
          description: i18n._('LANDING_DELIVERY_METHODS_DESCRIPTION'),
        },
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/modes-de-paiement',
    name: 'payment-modes',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'paiements',
        metaInfos: {
          title: i18n._('LANDING_PAYMENT_METHODS_TITLE'),
          description: i18n._('LANDING_PAYMENT_METHODS_DESCRIPTION'),
        },
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/pages/partenaires',
    name: 'landing-page-partner',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'partner',
        metaInfos: {
          title: i18n._('LANDING_PARTNER_TITLE'),
          description: i18n._('LANDING_PARTNER_DESCRIPTION'),
        },
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: useAnalyticService(),
      })
    },
  },
  {
    path: '/pages/fournisseurs',
    name: 'landing-page-provider',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'provider',
        metaInfos: {
          title: i18n._('LANDING_PROVIDER_TITLE'),
          description: i18n._('LANDING_PROVIDER_DESCRIPTION'),
        },
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: useAnalyticService(),
      })
    },
  },
]
